var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.8836.0848867c-5.64152.6132083-10.179262 5.1509433-10.7924705 10.6698133-.7358495 6.1321 3.0660405 11.4057 8.4622705 13.1227v-2.8208s-.49057.1226-1.10377.1226c-1.71699 0-2.45284-1.4717-2.57548-2.3301-.12264-.4906-.36792-.8585-.73585-1.2265-.36792-.1226-.49056-.1226-.49056-.2452 0-.2453.36792-.2453.49056-.2453.73585 0 1.34906.8585 1.59434 1.2264.61321.9811 1.34906 1.2264 1.71699 1.2264.49056 0 .85849-.1226 1.10377-.2453.12264-.8585.49057-1.717 1.22642-2.2075-2.82076-.6132-4.90567-2.2076-4.90567-4.9057 0-1.3491.61321-2.69811 1.4717-3.67924-.12264-.24529-.24528-.85849-.24528-1.71699 0-.49056 0-1.22641.36792-1.96226 0 0 1.71699 0 3.43397 1.59434.61324-.24528 1.47174-.36792 2.33014-.36792.8585 0 1.717.12264 2.4529.36792 1.5943-1.59434 3.4339-1.59434 3.4339-1.59434.2453.73585.2453 1.4717.2453 1.96226 0 .98114-.1226 1.4717-.2453 1.71699.8585.98113 1.4717 2.20754 1.4717 3.67924 0 2.6981-2.0849 4.2925-4.9056 4.9057.7358.6132 1.2264 1.717 1.2264 2.8207v4.0472c5.0283-1.5943 8.5849-6.2547 8.5849-11.651 0-7.35845-6.2547-13.122604-13.6132-12.2641133z",
    fill: "#869ab8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.781b1d8922265fec45569dde6e30d45c.svg";
export { ForwardRef as ReactComponent };